import {History, Location} from 'history'
import QueryString from 'querystring'

import {clearSearch} from './window-location'

export const replaceSearch = (history: History, location: Location, values: any) => {
  const parsed = QueryString.parse(clearSearch(location.search))
  const updated = {...parsed, ...values}
  Object.keys(values).forEach(key => {
    if (!updated[key]) {
      delete updated[key]
    }
  })
  history.replace({hash: location.hash, search: QueryString.stringify(updated)})
}
